import { render, staticRenderFns } from "./GuiaMotivoGlosa.vue?vue&type=template&id=1ba3c65e&scoped=true&"
import script from "./GuiaMotivoGlosa.vue?vue&type=script&lang=js&"
export * from "./GuiaMotivoGlosa.vue?vue&type=script&lang=js&"
import style0 from "./GuiaMotivoGlosa.vue?vue&type=style&index=0&id=1ba3c65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3c65e",
  null
  
)

export default component.exports